export default __webpack_public_path__ + "static/me-e72e1660c1eb99ece2f9959eee8508be.jpg";